<div class="fixed top-0 left-1/2 -translate-x-1/2 z-9999">
  <div  *ngIf="!(isConnected$ | async)" class="bg-orange-200 text-black dark:text-white dark:bg-orange-700 px-6 py-2 rounded-sm leading-3 flex flex-col sm:flex-row gap-1 items-center justify-between text-md">
      <strong class="whitespace-nowrap">No connection.</strong>
      <div class="whitespace-nowrap flex">
        <div>Trying to reconnect in</div>
        <p class="min-w-5 font-semibold text-center">{{timer$ | async}}</p>
        <div>second(s).</div>
      </div>
    <div class="cursor-pointer underline whitespace-nowrap font-medium" (click)="reconnect()">Reconnect now</div>
  </div>
</div>